/** @jsxImportSource @emotion/react */
import React from 'react';
import { Button, Space, Switch, Typography } from 'antd';
import { FORECAST_METRICS } from '../constants';
import type { ForecastMetricKey } from '../constants';
import { styles } from '../styles';

const { Text } = Typography;

interface Props {
  selectedMetric: ForecastMetricKey;
  showHarvestDailyBars: boolean;
  showOptimalZone: boolean;
  onSelectMetric: (key: ForecastMetricKey) => void;
  onToggleHarvestBars: () => void;
  onToggleOptimalZone: (checked: boolean) => void;
  plantingQuantity?: number;
  showBatchQuantityMetric?: boolean;
}

const MetricSelector: React.FC<Props> = ({
  selectedMetric,
  showHarvestDailyBars,
  showOptimalZone,
  onSelectMetric,
  onToggleHarvestBars,
  onToggleOptimalZone,
  plantingQuantity = 1,
  showBatchQuantityMetric = false,
}) => {
  const isBatch = showBatchQuantityMetric || plantingQuantity > 1;
  const optimalZoneAvailable = ['soilMoisturePct', 'tempAvgC', 'totalDliMol', 'photoperiodHours'].includes(selectedMetric);

  return (
    <>
      <Space wrap>
        {FORECAST_METRICS.filter((m) => !(m as any).isBatchOnly || isBatch).map((metric) => {
          const isActive = !showHarvestDailyBars && selectedMetric === metric.key;
          return (
            <Button
              key={metric.key}
              size="small"
              type={isActive ? 'primary' : 'default'}
              onClick={() => onSelectMetric(metric.key)}
              style={isActive
                ? { backgroundColor: metric.color, borderColor: metric.color }
                : { color: metric.color, borderColor: metric.color }}
            >
              {metric.label}
            </Button>
          );
        })}
        <Button
          key="harvest-daily-bars"
          size="small"
          type={showHarvestDailyBars ? 'primary' : 'default'}
          onClick={onToggleHarvestBars}
          style={showHarvestDailyBars
            ? { backgroundColor: '#389e0d', borderColor: '#389e0d' }
            : { color: '#389e0d', borderColor: '#389e0d' }}
        >
          Урожай по дням
        </Button>
      </Space>
      <Space size={8} align="center">
        <Switch
          size="small"
          checked={showOptimalZone}
          onChange={onToggleOptimalZone}
          disabled={showHarvestDailyBars || !optimalZoneAvailable}
        />
        <Text type="secondary" css={styles.smallText}>
          Зона оптимума
          {showHarvestDailyBars
            ? ' (недоступна в режиме дневной урожайности)'
            : (!optimalZoneAvailable
              ? ' (доступна для «Температура», «Влага почвы», «Освещение (DLI)» и «Фотопериод»)' 
              : '')}
        </Text>
      </Space>
    </>
  );
};

export default MetricSelector;
